import { updateQueryParams } from 'utils/wrappers';

import Base from 'app/collections/base';
import DropdownSelection from 'app/models/dropdown_selection';

export default Base.extend({
  model: DropdownSelection,

  initialize(models, { initialChoices, urlParamKey }) {
    if (initialChoices) {
      models.forEach(m => m.setCurrentChoice(initialChoices));
    }
    this.urlParamKey = urlParamKey;
    if (this.urlParamKey) {
      this.listenTo(this, 'change', this.setUrlParams);
    }
  },

  setUrlParams() {
    updateQueryParams({
      [this.urlParamKey]: this.getParams(),
    });
  },

  getParams() {
    return this.reduce((o, m) => ({ ...o, ...m.getParams() }), {});
  },
});



// WEBPACK FOOTER //
// ./app/collections/dropdown_selections.js